// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "passengers__recommend__icon-3tXoT";
var _4 = "recommend__label-3WeqK";
var _5 = "row__serviceHeader-22OYW";
var _6 = "disclaimer__wrp-hh8lP";
var _7 = "disclaimer__icon-1cKKH";
var _8 = "disclaimer-u_SB6";
var _9 = "controls__button-jGYVn";
var _a = "airplane__amenities-2-zz3";
var _b = "serviceInfo__selectable-1HXp5";
var _c = "seat-1KmaV";
var _d = "map-14Sg4";
var _e = "seatsInfo-3n9zz";
var _f = "slideBottom__header-Is3WB";
var _10 = "seatsInfo_content-1XkGS";
var _11 = "airplane__segment-1l_wW";
var _12 = "airplane__seatsDetails-7CO0f";
export { _1 as "__esModule", _2 as "mobile", _3 as "passengers__recommend__icon", _4 as "recommend__label", _5 as "row__serviceHeader", _6 as "disclaimer__wrp", _7 as "disclaimer__icon", _8 as "disclaimer", _9 as "controls__button", _a as "airplane__amenities", _b as "serviceInfo__selectable", _c as "seat", _d as "map", _e as "seatsInfo", _f as "slideBottom__header", _10 as "seatsInfo_content", _11 as "airplane__segment", _12 as "airplane__seatsDetails" }
export default { "__esModule": _1, "mobile": _2, "passengers__recommend__icon": _3, "recommend__label": _4, "row__serviceHeader": _5, "disclaimer__wrp": _6, "disclaimer__icon": _7, "disclaimer": _8, "controls__button": _9, "airplane__amenities": _a, "serviceInfo__selectable": _b, "seat": _c, "map": _d, "seatsInfo": _e, "slideBottom__header": _f, "seatsInfo_content": _10, "airplane__segment": _11, "airplane__seatsDetails": _12 }
